import {
  DatePicker,
  Button,
  Form,
  Input,
  Row,
  Col,
  Select,
  InputNumber,
} from "antd";
import { useTranslation } from "react-i18next";

import {
  MailOutlined,
  FileTextOutlined,
  IdcardOutlined,
} from "@ant-design/icons";

export default function SupplementForm({ form, onSubmit }) {
  const { t } = useTranslation();

  return (
    <Form
      layout="vertical"
      name="Supplement_Form"
      id="Supplement_Form"
      form={form}
      onFinish={onSubmit}
      style={{
        maxWidth: 600,
        margin: "0 auto",
        marginTop: "30px",
        padding: "20px",

        background: "#fff",
      }}
    >
      <Row gutter={16}>
        {/* Champ Nom */}
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.name")}
              </span>
            }
            name="name"
            rules={[
              {
                required: true,
                message: t("supplements.crud.form.error.label.required.name"),
              },
              {
                min: 3,
                message: t("supplements.crud.form.error.label.name.minLength"),
              },
            ]}
          >
            <Input
              className="custom-input"
              style={{
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                height: "40px", // Assure que la hauteur est la même
              }}
              placeholder={t("supplements.crud.form.placeholder.name")}
            />
          </Form.Item>
        </Col>

        {/* Champ Prix */}
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.price")}
              </span>
            }
            name="price"
            rules={[
              {
                required: true,
                message: t("supplements.crud.form.error.label.required.price"),
              },
              {
                type: "number",
                min: 100,
                message: t("supplements.crud.form.error.label.price.minValue"),
              },
            ]}
          >
            <InputNumber
              min={100}
              style={{
                width: "100%",
                height: "40px",
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              }}
              className="custom-input"
              placeholder={t("supplements.crud.form.placeholder.price")}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault(); // Bloque l'entrée des lettres
                }
              }}
            />
          </Form.Item>
        </Col>
        {/* Champ Description */}
        <Col xs={24}>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold", color: "#333" }}>
                {t("supplements.table.column.description")}
              </span>
            }
            name="description"
            rules={[
              {
                required: true,
                message: t(
                  "supplements.crud.form.error.label.required.description"
                ),
              },
              {
                min: 5,
                message: t(
                  "supplements.crud.form.error.label.description.minLength"
                ),
              },
            ]}
          >
            <Input.TextArea
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
              rows={4}
              style={{
                borderRadius: "8px",
                padding: "10px",
                border: "1px solid #ddd",
                boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
                resize: "none",
              }}
              placeholder={t("supplements.crud.form.placeholder.description")}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
